import React, { InputHTMLAttributes } from 'react';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  containerClassName?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  containerClassName = '',
  className = '',
  ...props
}) => {
  return (
    <label className={`flex items-center cursor-pointer ${containerClassName}`}>
      <input
        checked
        type="checkbox"
        className={`w-4 h-4 text-blue-600 border border-solid border-gray-300 rounded focus:ring-2 focus:ring-blue-500 ${className}`}
        {...props}
      />
      {label && <span className="ml-2 text-sm text-gray-700">{label}</span>}
    </label>
  );
};
